// extracted by mini-css-extract-plugin
export default {"modalAction":"styles-scoped__modalAction--vPAPg","contentModal":"styles-scoped__contentModal--l_n0t","line":"styles-scoped__line--A0X7u"};